export default (t) => [
  {
    text: t('Attribute Name'),
    value: 'name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Code'),
    value: 'code',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Option Count'),
    value: 'options_count',
    sortable: false,
    width: 150,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 200,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 150
  },
];
